import React, { useEffect, useState } from "react";
import Window from "./Window";
import { PACE, PaceKind, SLOW_DOWN_EVENT } from "../pace";

const WHAT: Record<PaceKind, string> = {
  post: "posts",
  comment: "comments",
  letter: "letters",
  request: "pen pal requests",
  kudos: "kudos",
  report: "reports",
};

// The friendly note shown when someone sends things faster than the
// speed limits allow (see src/pace.ts).
export default function SlowDownNotice() {
  const [note, setNote] = useState<{ kind: PaceKind; until: number } | null>(null);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const show = (e: Event) => {
      const { kind, wait } = (e as CustomEvent<{ kind: PaceKind; wait: number }>).detail;
      setNow(Date.now());
      setNote({ kind, until: Date.now() + wait * 1000 });
    };
    window.addEventListener(SLOW_DOWN_EVENT, show);
    return () => window.removeEventListener(SLOW_DOWN_EVENT, show);
  }, []);

  useEffect(() => {
    if (!note) return;
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, [note]);

  if (!note) return null;
  const left = Math.max(0, Math.ceil((note.until - now) / 1000));
  const close = () => setNote(null);

  return (
    <div
      className="viewer-backdrop !z-50"
      role="dialog"
      aria-modal="true"
      aria-label="Just a moment"
      onClick={(e) => e.target === e.currentTarget && close()}
    >
      <div className="viewer-letter !max-w-md">
        <Window title="just_a_moment.exe" tone="tan" minimizable={false}>
          <h2 className="window-heading">Just a moment, pen pal ✿</h2>
          <p>
            To keep bots and spammers from flooding the site, everyone waits a
            little between {WHAT[note.kind]} ({PACE[note.kind]} seconds). You
            didn't do anything wrong!
          </p>
          <p className="mt-2 font-bold" aria-live="polite">
            {left > 0
              ? `You can send it in ${left} second${left === 1 ? "" : "s"}. Your writing is still here.`
              : "All set. You can send it now."}
          </p>
          <div className="btn-row mt-4">
            <button type="button" className="btn" onClick={close} autoFocus>
              Okay
            </button>
          </div>
        </Window>
      </div>
    </div>
  );
}
